import { useCallback } from 'react';
import { trackAddDuplicateAnalytics as trackAddDuplicateAnalyticsImpl } from './utils/trackAddDuplicateAnalytics';

/**
 * Memoized analytics callback for duplicate cabinet events.
 * Returns a stable function reference for use in WallDesigner and WallDesignerDndEnabled.
 */
export function useTrackAddDuplicateAnalytics(trackChooseCabinetOverlayEvent, trackAddItemToWallAnalyticsEvent) {
  return useCallback(
    (basePrice, itemId, quantity = 1) => trackAddDuplicateAnalyticsImpl(
      trackChooseCabinetOverlayEvent,
      trackAddItemToWallAnalyticsEvent,
      basePrice,
      itemId,
      quantity
    ),
    [trackChooseCabinetOverlayEvent, trackAddItemToWallAnalyticsEvent]
  );
}
